import { RouteComponentProps } from "@reach/router";
import React, { useState, useEffect } from "react";

const OperationsIndex = (props: RouteComponentProps) => <>Ops</>;

export default OperationsIndex;
